class ShowMore extends HTMLElement {
  constructor() {
    super();

    this.container = document.querySelector(`${this.dataset.targetWrapper}`);
    this.url = this.getAttribute('data-next-page-url');
    this.button = this.querySelector('button');

    this.init();
  }

  init() {
    if (!this.container || !this.url || !this.button) return;

    this.button.addEventListener('click', (event) => {
      this.getData(this, event);
    });

    this.button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      this.getData(this, event);
    });
  }

  getData() {
    this.toggleLoading(true);

    fetch(this.url)
      .then(response => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

        this.addItems(parsedHTML);
        this.changeUrl(parsedHTML);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        this.toggleLoading(false);
      });
  }

  addItems(html) {
    const childItemsSelector = this.dataset.childItemsSelector;
    const itemsFromResponse = html.querySelectorAll(childItemsSelector);

    itemsFromResponse.forEach((item) => {
      this.container.append(item);
    });
  }

  changeUrl(html) {
    const showMoreComponentFromResponse = html.querySelector('[data-next-page-url]') || null;

    this.url = showMoreComponentFromResponse 
      ? showMoreComponentFromResponse.getAttribute('data-next-page-url') 
      :  null;

    if (!this.url) {
      this.classList.add('hidden');
      return false;
    }

    this.setAttribute('data-next-page-url', this.url);
  }

  toggleLoading(isLoading) {
    this.button.toggleAttribute('disabled', isLoading);
    this.classList.toggle('loading', isLoading);
  }
}
customElements.define('show-more', ShowMore);
